export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Recordings-8cc7a8bcc868c9655042529c6a292aea.webp";